import { createSlice } from "@reduxjs/toolkit";

// Helper function to load from localStorage
const loadState = (key, fallback) => {
  const saved = localStorage?.getItem(key);
  return saved ? JSON.parse(saved) : fallback;
};

const initialState = {
  selectedCodeBookCode: null,
  copiedCodes: [], // Supports multiple copied codes
  selectedTabKeyCoding: null,
  episodesData: [],
  trackHistory: [],
  redoStack: [],
  diagnosisStates: {
    principal: loadState("principalDiagnosisState", []),
    additional: loadState("additionalDiagnosisState", []),
    procedure: loadState("procedureCodesState", []),
  },
  
};
// console.log(initialState.diagnosisStates,'slcie');

const CodingScreenSlice = createSlice({
  name: "CodingScreenSlice",
  initialState,
  reducers: {
    setSelectedCodeBookCode: (state, action) => {
      state.selectedCodeBookCode = action.payload;
    },
    setCopiedCodes: (state, action) => {
      state.copiedCodes = action.payload;
    },
    setSelectedTabKeyCoding: (state, action) => {
      state.selectedTabKeyCoding = action.payload;
    },
    setEpisodesData: (state, action) => {
      state.episodesData = action.payload;
    },
    setTrackHistory: (state, action) => {
      state.trackHistory = action.payload;
    },
    setRedoStack: (state, action) => {
      state.redoStack = action.payload;
    },
    setDiagnosisStates: (state, action) => {
      state.diagnosisStates = action.payload;
      // console.log(state,'pps');
      
      // Persist diagnosis states to localStorage
      localStorage.setItem("principalDiagnosisState", JSON.stringify(action.payload.principal));
      localStorage.setItem("additionalDiagnosisState", JSON.stringify(action.payload.additional));
      localStorage.setItem("procedureCodesState", JSON.stringify(action.payload.procedure));
    },
  },
});

export const {
  setSelectedCodeBookCode,
  setCopiedCodes,
  setSelectedTabKeyCoding,
  setEpisodesData,
  setTrackHistory,
  setRedoStack,
  setDiagnosisStates,
  updatePrincipalDiagnosis,
  updateAdditionalDiagnosis,
  updateProcedureCodes,
} = CodingScreenSlice.actions;

export default CodingScreenSlice.reducer;
